import { course_levelQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';

export const getCourseLevelsForSelect = (courseLevels?: course_levelQuery['course_level']): HSMSSelectOption[] => {
  if (courseLevels) {
    const courseLevelsForSelect = courseLevels.map((courseLevel) => {
      return {
        value: courseLevel.id,
        label: courseLevel.name,
      };
    });

    return courseLevelsForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
